import getSDK from "@ua/web-sdk"

import {
  combineReducers,
  configureStore,
  getDefaultMiddleware,
} from "@reduxjs/toolkit"
import { useDispatch } from "react-redux"
import {
  contactSlice,
  channelSlice,
  analyticsSlice,
  metadataSlice,
  debugSlice,
} from "./reducers"
import { loadState } from "./storage"

const rootReducer = combineReducers({
  debug: debugSlice.reducer,
  metadata: metadataSlice.reducer,
  contact: contactSlice.reducer,
  channel: channelSlice.reducer,
  analytics: analyticsSlice.reducer,
})

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware({
    thunk: { extraArgument: { sdkPromise: getSDK() } },
  }),
  preloadedState: loadState(),
})

export const { actions: debugActions } = debugSlice
export const { actions: metadataActions } = metadataSlice
export const { actions: contactActions } = contactSlice
export const { actions: channelActions } = channelSlice
export const { actions: analyticsActions } = analyticsSlice

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>()

export default store
